export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14633.e06a7787.jpg";